import { amplitudeLib } from 'freedom-shared';

/**
 * @description Ивент чтобы строить стартовую воронку, и понимать насколько часто пользователи скролят горящие билеты
 * @trigger При нажатии на стрелку. При ручном скроле
 * @location Главная страница в MiniApp. Переходная страница в самих горящих билетах
 */
export const hotOffersScroll = ({
  direction,
  source,
}: {
  direction: 'right' | 'left';
  source: string;
}) => {
  amplitudeLib.logEvent('avfree_hot_offers_scroll', { direction, source });
};

/**
 * @description Поиск клиентом самого выгодного предложения
 * @trigger Нажатие на кнопку центы "от *** ***"
 * @location Детальная страница с городами внутри страны
 */
export const hotOffersSearchClick = ({
  origCityCode,
  destCityCode,
  date,
  price,
}: {
  origCityCode: string;
  destCityCode: string;
  date: string;
  price: string;
}) => {
  amplitudeLib.logEvent('avfree_hot_offers_search_click', {
    orig_city_code: origCityCode,
    dest_city_code: destCityCode,
    date,
    price,
  });
};

/**
 * @description Открытие клиентом внутри страны всех дат перелетов
 * @trigger Нажатие на кнопку "Все даты" / "Все предложения"
 * @location Детальная страница с городами внутри страны
 */
export const hotOffersAllDatesClick = ({
  origCityCode,
  destCityCode,
}: {
  origCityCode: string;
  destCityCode: string;
}) => {
  amplitudeLib.logEvent('avfree_hot_offers_all_dates_click', {
    orig_city_code: origCityCode,
    dest_city_code: destCityCode,
  });
};

/**
 * @description Изменение города вылета
 * @trigger Изменение города вылета
 * @location Детальная страница с городами внутри страны
 */
export const hotOffersOriginCityChange = ({
  origCityCode,
  source,
}: {
  origCityCode: string;
  source: string;
}) => {
  amplitudeLib.logEvent('avfree_hot_offers_origin_city_change', {
    orig_city_code: origCityCode,
    source,
  });
};

export const hotOffersPageOpen = ({
  cityFrom,
  countryName,
}: {
  cityFrom: string;
  countryName: string;
}) => {
  amplitudeLib.logEvent('avfree_hot_offers_page_open', {
    city_from: cityFrom,
    country_name: countryName,
  });
};
